import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class VendorSearchResultDto {
    location: string;
    community: string;
    communityId: number;
    vendorName: string;
    vendorType: string;
    isActive: boolean;
    approved: boolean;

    @Type(() => FileInfoDisplayResultDto)
    w9FileInfo: FileInfoDisplayResultDto;

    is1099Vendor: boolean;
    contactName: string;
    email: string;
    phone: string;
    fax: string;
    address: string;
}
